import { render, staticRenderFns } from "./PzLanguage.vue?vue&type=template&id=2347fe1a"
import script from "./PzLanguage.vue?vue&type=script&lang=js"
export * from "./PzLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2347fe1a')) {
      api.createRecord('2347fe1a', component.options)
    } else {
      api.reload('2347fe1a', component.options)
    }
    module.hot.accept("./PzLanguage.vue?vue&type=template&id=2347fe1a", function () {
      api.rerender('2347fe1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lang/PzLanguage.vue"
export default component.exports